import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { AppConfig } from '@/app/config'

/** No-op when `sentryDsn` is unset, e.g. local/dev/preview with no BetterStack source configured. */
export function initErrorTracking(app: App, config: AppConfig): void {
  if (!config.sentryDsn) return

  Sentry.init({
    app,
    dsn: config.sentryDsn,
    integrations: [Sentry.replayIntegration()],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
  })
}
